const url = process.env.GATSBY_PRIMARY_URL;
export const schemas = [
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "Bushbuck ",
    url,
    description:
      "Bushbuck is your online store for the world's toughest, purpose-built hunting and outdoor clothing, gear and accessories. ",
    image:
      "https://cdn.shopify.com/s/files/1/0200/6190/t/117/assets/logo.png?42603",
    logo: "https://cdn.shopify.com/s/files/1/0200/6190/t/117/assets/logo.png?42603",
    sameAs: [
      "https://facebook.com/bushbuckoutdoors",
      "https://instagram.com/bushbucknz",
      "https://youtube.com/channel/UCosCFGMwbSnDoEED3_DrQEg",
    ],
    telephone: "0800 2874 2825",
    address: {
      "@type": "PostalAddress",
      streetAddress: "51 Princess Street, Riccarton",
      addressLocality: "Christchurch",
      addressRegion: "Canterbury",
      postalCode: "8041",
      addressCountry: "New Zealand",
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "Bushbuck",
    alternateName: "Bushbuck",
    url,
    potentialAction: {
      "@type": "SearchAction",
      "query-input": "required name=query",
      target: "https://bushbuck.co.nz/search?q={query}",
    },
  },
];
